import style from "./style.module.scss";
import { useState, useRef } from "react";
import { FcNext, FcPrevious } from "react-icons/fc";

import Item from "./Item";
import FancyButtons from "../FancyButtons";

function Testimonial({ text, page }) {

    const [scrollPos, setScrollPos] = useState(0);
    const itemsParent = useRef();

    const testimonials = text[page]?.testimonials;
    if (!testimonials) return null;


    function scroll(forward) {

        if (forward) {
            document.querySelector(`#testItem-${scrollPos}`)?.classList?.add(style.shrink);
        } else {
            document.querySelector(`#testItem-${scrollPos - 1}`)?.classList?.remove(style.shrink);
        }

        let newPos = Math.max(0, Math.min(testimonials.length, scrollPos + (forward ? 1 : -1)));
        setScrollPos(newPos);
    }

    return <div className={style.Testimonial}>

        <div className={style.upper}>
            <div className={style.navigator}>
                {(scrollPos > 0) && <FcPrevious onClick={() => scroll(false)} />}
                <div />
                {(scrollPos < (testimonials.length - 1)) && <FcNext onClick={() => scroll(true)} />}
            </div>

            <div className={style.items} ref={itemsParent}>
                {
                    testimonials.map((ts, i) => <Item key={ts.text} author={ts.author} text={ts.text} image={ts.image} id={`testItem-${i}`} />)
                }
            </div>
        </div>
        <FancyButtons />
    </div>
}

export default Testimonial;